/* !
 * jQuery index v1.0.0
 * Copyright 2019, Connecty Inc.
 */
(function($, SDGS){
	const a = 'is-active';
	const v = 'is-visible';

	$('.idx-slider').slick({
        infinite: true,
        speed: 1500,
        autoplay: true,
        autoplaySpeed: 5000,
        slidesToShow: 1,
        arrows: false,
        dots: false,
    });

	if($('.js-top-ranking').length) {
		const getJSONranking = () => {
			return $.ajax({
				type: 'GET',
				url: 'https://storage.googleapis.com/connecty-cdp.appspot.com/cmsod/190/sdgs.fan/tag_ranking.json',
			});
		};
		getJSONranking().done((data) => {
			// console.log(data.items,'data');
			let HTML = '';
			for(let i=0; i < 10; i++) {
				// console.log(i,'i');
				HTML +='<li class="pure-u-1-2 pure-u-md-1-2"><p><span>'+('00' + data.items[i].rank).slice( -2 )+'位：</span><a href="/sdgs/article/tag/'+data.items[i]._key+'/" class="mod-a rt_cf_n_tags">#'+data.items[i].cf_nt_name_d+'</a></p></li>';
				// console.log(HTML,'HTML');
			}
			$('.js-top-ranking').append(HTML);
		});
	}
})(window.jQuery, window.SDGS);
